import { Dialog } from 'primereact/dialog'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { Button } from 'primereact/button'
import { CommonContext } from '../common/context/commonContext'
import { InventorySurveyDetailProps, InventorySurveyGoodsDetail } from '../../types/inventory'
import { markHyphen } from '../../utils/inputText'
import moment from 'moment/moment'
import { Calendar, CalendarChangeEvent } from 'primereact/calendar'
import { InputNumber } from 'primereact/inputnumber'
import { cloneDeep } from 'lodash'
import { useTranslation } from 'react-i18next'
import { tokens } from 'locales/tokens'

const InventorySurveyShlfYmd = (props: InventorySurveyDetailProps) => {
    const { $toast, $http } = useContext(CommonContext)
    const { t } = useTranslation()
    const calendar = useRef<Calendar>(null)
    const [goods, setGoods] = useState<InventorySurveyGoodsDetail[]>([])
    const [disabledDates, setDisabledDates] = useState<Date[]>([])

    useEffect(() => {
        if (props.inventoryGoods) {
            if (props.inventoryGoods.shlfYn === 'N') {
                const date = moment('99991231')
                props.inventoryGoods.invnsuShlfYmd = date.format('YYYYMMDD')
                props.inventoryGoods.invnsuShlfYmdDt = date.toDate()
            }
            setGoods([props.inventoryGoods])
        }
    }, [props.inventoryGoods])

    useEffect(() => {
        const disabledDatesTemp: Date[] = goods.map((good) => {
            return moment(good.invnsuShlfYmd, 'YYYYMMDD').toDate()
        })
        setDisabledDates(disabledDatesTemp)
    }, [goods])

    const onClickMConfirm = async () => {
        const filterGoods = goods.filter((v) => v.invnsuShlfYmd)

        if (filterGoods.length === 0) {
            $toast({ title: t(tokens.common.fail), text: t(tokens.common.please_enter_expiration_date_and_quantity), icon: 'warn' })
            return
        }
        const result = await $http().post('/inventory-survey', filterGoods)
        if (result && props.onHide) {
            $toast({ title: t(tokens.common.success), text: t(tokens.common.inventory_investigation_processing_completed), icon: 'success' })
            props.onHide(true)
        }
    }

    const header = () => {
        return (
            <>
                <div className="grid py-0">
                    <div>{props.locationDetail?.lctPathNm}</div>
                </div>
            </>
        )
    }

    const onHide = (isChange?: boolean) => {
        if (!isChange) {
            goods.forEach((v) => {
                v.invnsuShlfYmd = moment(props.inventoryGoods?.invnsuShlfYmd).format('YYYYMMDD')
                v.invnsuQty = 0
            })
        }
        if (props.onHide) {
            props.onHide(false)
        }
    }

    const footer = () => {
        return (
            <div className="flex justify-content-center pb-0">
                <Button className="rdms-button p-button-secondary mx-2" label={t(tokens.common.cancel)} size="large" onClick={() => onHide()} />
                <Button className="rdms-button p-button-success mx-2" label={t(tokens.common.complete)} size="large" onClick={onClickMConfirm} />
            </div>
        )
    }

    const onChangeDate = (e: CalendarChangeEvent, index: number) => {
        if (e && e.value instanceof Date) {
            const goodsList = [...goods]
            goodsList[index].invnsuShlfYmdDt = e.value
            goodsList[index].invnsuShlfYmd = moment(e.value).format('YYYYMMDD')
            setGoods([...goodsList])

            setTimeout(() => calendar.current?.hide(), 150)
        }
    }

    const onClickAddGoodsYmd = () => {
        const tempGoods = cloneDeep(goods[goods.length - 1])
        tempGoods.inventorySurveyDetailSeq = props.inventoryGoods?.inventorySurveyDetailSeq
        tempGoods.invnSeq = (props.maxNumber || 0) + 1
        tempGoods.shlfYmd = ''
        tempGoods.invnQty = 0
        tempGoods.invnsuQty = 0

        if (tempGoods.shlfYn === 'N') {
            const date = moment('99991231')
            tempGoods.invnsuShlfYmd = date.format('YYYYMMDD')
            tempGoods.invnsuShlfYmdDt = date.toDate()
        } else {
            tempGoods.invnsuShlfYmd = ''
            tempGoods.invnsuShlfYmdDt = ''
            tempGoods.shlfYmd = props.inventoryGoods?.shlfYmd
        }
        const tempGoodsList = [...goods]
        tempGoodsList.push(tempGoods)
        setGoods([...tempGoodsList])
    }

    const removeGoods = (idx: number) => {
        const removeItems = goods.filter((v, index) => index !== idx)
        setGoods(removeItems)
    }

    return (
        <Dialog
            headerClassName="pb-3"
            header={header()}
            visible={props.visible}
            onHide={() => props.onHide(false)}
            contentClassName="px-3 pb-0"
            style={{ width: '92vw' }}
            footer={footer}
            closable={false}
        >
            <div className="p-0 my-2">
                <div className="col-12 flex m-0 p-0">
                    <div className="col-4 text-lg flex font-bold rdms-text-deepblue p-0 pl-1">{t(tokens.common.expiration_date)}</div>
                    <div className="col-8 text-lg flex font-bold rdms-text-deepblue p-0 pl-1">{t(tokens.common.quantity)}</div>
                </div>
                {goods &&
                    goods.map((g, index) => (
                        <div key={index} className="col-12 flex m-0 p-0 align-items-center">
                            <div className="col-4 p-0">
                                <Calendar
                                    ref={calendar}
                                    id="invnsuShlfYmd"
                                    value={g.invnsuShlfYmdDt}
                                    selectionMode="single"
                                    dateFormat="y-mm-dd"
                                    // minDate={minDate}
                                    style={{ height: '30.75px' }}
                                    readOnlyInput
                                    className="mt-1"
                                    /*showIcon*/
                                    disabledDates={disabledDates}
                                    onChange={(v) => onChangeDate(v, index)}
                                    disabled={g.shlfYn === 'N'}
                                />
                            </div>
                            <div className="col-5 p-0 mt-1 ml-1">
                                <InputNumber
                                    id="invnsuQty"
                                    className="p-inputtext-sm"
                                    placeholder={t(tokens.common.quantity)}
                                    value={g.invnsuQty}
                                    inputStyle={{ width: '100%' }}
                                    style={{ height: '30.75px' }}
                                    min={0}
                                    maxFractionDigits={g.gdslsUnitCd === 'KG' ? 1 : 0}
                                    step={g.gdslsUnitCd === 'KG' ? 0.1 : 1}
                                    showButtons
                                    onChange={(event) => {
                                        let row = goods[index]
                                        if (typeof event.value === 'number' && event.value >= 0) {
                                            row.invnsuQty = event.value
                                            setGoods([...goods])
                                        }
                                    }}
                                />
                            </div>
                            <div className="col-2 align-self-center p-0 mt-1 ml-1">{markHyphen(g.gdslsUnitCd)}</div>
                            <div className="col-1">
                                <Button
                                    icon="pi pi-minus"
                                    className="p-button-danger"
                                    onClick={() => removeGoods(index)}
                                    disabled={goods.length === 1}
                                />
                            </div>
                        </div>
                    ))}
                <Button className="w-full rdms-button p-0 mt-2 mb-3" label={`+ ${t(tokens.common.add)}`} onClick={onClickAddGoodsYmd} />
            </div>
        </Dialog>
    )
}

export default InventorySurveyShlfYmd
